<template>
  <div class="container">
    <div class="box">
      <van-form @submit="onSubmit">
        <div>
          <img class="icon" src="../assets/img/login-ic1.png" alt="">
          <span class="lab">账号</span>
        </div>
        <van-field
          v-model="username"
          name="username"
          label=""
          placeholder="请输入您的账号"
          :rules="[{ required: true, message: '' }]"
        />
        <div class="mg20">
          <img class="icon" src="../assets/img/login-ic2.png" alt="">
          <span class="lab">密码</span>
        </div>
        <van-field
          v-model="password"
          type="password"
          name="password"
          label=""
          placeholder="请输入密码"
          :rules="[{ required: true, message: '' }]"
        />
        <div class="post">
          <van-button round block type="info" native-type="submit">登录</van-button>
        </div>
      </van-form>
      <div class="tip">属于充电运营定制服务，完成授权登录才可以享受</div>
    </div>  
  </div>
</template>

<script>
  import axios from '@/axios.js';
  import {saveToLocal,loadFromLocal} from '../localStorage';
  import {NavBar,Icon,Image,Toast,Loading,Form,Field,Button} from 'vant';
  import Config from '@/config.js';
  let wxData=Config.wxData;
  export default {
    data() {
      return {
        username: '',
        password: '',
      };
    },
    components: {
      [NavBar.name]:NavBar,
      [Icon.name]:Icon,
      [Image.name]:Image,
      [Toast.name]:Toast, 
      [Loading.name]:Loading,
      [Form.name]:Form,
      [Field.name]:Field,
      [Button.name]:Button,
    },
    methods: {
      changePage(url){
        this.$router.push({path: url+".html",query:{}})
      },
      getUrlParam (name) {
        let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
        let r = (window.location.search.substr(1) || window.location.hash.split('?')[1])['match'](reg)
        if (r != null) return decodeURI(unescape(r[2]))
        else return null
      },
      onSubmit() {
        //登录
        Toast.loading({
          message: '登录中...',
          forbidClick: true,
        });
        axios.post("/auth/login",{
          userName: this.username,
          password: this.password,
          openId: localStorage.getItem(wxData.wechatid+'openId')
        }).then((res)=>{
          if(!res.isSuccess){
            Toast(res.message);
          }else{
            Toast.clear();
            localStorage.setItem(wxData.wechatid+'Token',res.data.accessToken);
            var account = {
              username: this.username,
              password: this.password,
            }
            localStorage.setItem(wxData.wechatid+'account',JSON.stringify(account));
            var id = this.$route.query.customInfomationId;
            if(id){
              this.$router.push({path: "khInfo.html",query:{rowId:id}})
            }else{
              this.changePage('home');
            }
          }
        })
      },
      onClickLeft() {
      },
    },
    computed:{
    },
    created () {
      localStorage.setItem(wxData.wechatid+'Token','');
      var account = localStorage.getItem(wxData.wechatid+'account');
      if(account){
        account = JSON.parse(account);
        this.username = account.username;
        this.password = account.password;
        this.onSubmit();
      }
      
    },
    mounted () {},
    destroyed () {}
  }
</script>

<style lang="less"> 
  @import "../assets/css/default.less";
  [v-cloak]{ 
    display:none !important;
  }
</style>
<style lang="less" scoped>
  body,html{width: 100%;height: 100%;background: #fff;}
  .container{
    width: 100%;
    height: 100vh;
    letter-spacing:0px;
    background: url(../assets/img/login-bg.png) no-repeat #fff;
    background-size: 100%;
    padding-top: 230px;
  }
  .box{
    width: 350px;
    height: 330px;
    background: #ffffff;
    border-radius: 14px;
    margin: 0 auto;
    padding: 30px 10px;
    box-shadow: 0px 2px 8px 2px rgba(154,187,184,0.16);
    .icon{
      width: 14px;
      vertical-align: top;
      margin: 2px 6px 0 17px;
    }
    .lab{
      font-size: 16px;
      font-weight: bold;
    }
  }
  .post{
    margin: 30px 16px;
    button{
      background: linear-gradient(180deg,#6bd0fd, #39a3fb);
      border: none;
    }
  }
  .tip{
    font-size: 12px;
    color: #9A9A9A;
    text-align: center;
  }
  .mg20{margin-top: 20px;}
</style>
